import * as React from "react";
import {CenteredCard as ShadcnCenteredCard, SlimCard as ShadcnSlimCard} from "../z70-shadcn/components/CenteredCard";

export function SlimCard(props) {
    return <ShadcnSlimCard {...props} />;
}

export function CenteredCard({showRobot = true, title, children, onBack, backText = "Back", maxWidth = 500, backgroundColor}) {
    return (
        <ShadcnCenteredCard 
            showRobot={showRobot}
            title={title}
            onBack={onBack}
            backText={backText}
            maxWidth={maxWidth}
            backgroundColor={backgroundColor}
        >
            {children}
        </ShadcnCenteredCard>
    );
}